"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.e11Error = e11Error;
exports.toE11Error = toE11Error;
exports.isE11Error = isE11Error;
exports.isE11ErrorOfType = isE11ErrorOfType;
function e11Error(errorData) {
    return toE11Error(new Error(errorData.title), errorData);
}
function toE11Error(e, errorData) {
    const timestamp = new Date().toISOString();
    let previousErrorData = undefined;
    previousErrorData = e.errorData
        ? { ...errorData.previousErrorData, [e.errorData.type ?? 'extraErrorData']: e.errorData }
        : errorData.previousErrorData;
    const previousMessage = errorData.message ? e.message : e.previousMessage;
    const message = errorData.message ?? e.message;
    const errorDataToUse = { timestamp, message, previousMessage, ...errorData, previousErrorData };
    e.errorData = errorDataToUse;
    return e;
}
function isE11Error(error) {
    const e11Error = error;
    return e11Error.errorData?.title !== undefined && e11Error.errorData?.type !== undefined;
}
function isE11ErrorOfType(error, type) {
    if (isE11Error(error)) {
        return error.errorData.type === type;
    }
    return false;
}
